import { Injectable } from "@angular/core";
import { UtilService } from "../../core/service/util.service";

@Injectable()
export class SideBarItems {
  empID: string = "";
  constructor(
    private _util: UtilService
  ) {}

  getSideBarItems() {
    return [
      {
        path: "home",
        title: "Home",
        type: "default",
        moduleName: "home",
        iconType: "material-icons",
        icon: "home",
        iconPath:this.getIconPath('dashboard'),
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        submenu: [],
        position: '8px',
        isPrivileged: false,
        // permissionName: "",
        isDisplayInProd: true
      },
      {
        path: "/accounts/account",
        title: "Accounts",
        type: "default",
        moduleName: "accounts",
        iconType: "material-icons",
        icon: "face",
        iconPath:'assets/images/icons/payroll-group-icon.svg',
        // this.getIconPath('payroll-group-icon')
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        submenu: [],
        position: '54px',
        isPrivileged: true,
        // // permissionName: Permission.EMPLOYEES,
        isDisplayInProd: true
      },
      {
        path: `/account-details/${this._util.accountID}`,
        title: "schedules",
        type: "default",
        moduleName: "schedules",
        iconType: "material-icons",
        icon: "face",
        iconPath: "assets/images/icons/new-my-profile-icon.svg",
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        hideInSideNav: true,
        submenu: [
          {
            path: `/account-details/${this._util.accountID}/schedules`,
            title: "schedules",
            type: "default",
            moduleName: "schedules",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-profile-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [],
            position: '54px',
            isPrivileged: true,
            // permissionName: Permission.ATTENDANCE_MINE,
            isDisplayInProd: true,
            hideInSideNav: true,
          },
          {
            path: `/account-details/${this._util.accountID}/Subscription`,
            title: "Subscription",
            type: "default",
            moduleName: "Subscription",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-profile-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [],
            position: '54px',
            isPrivileged: true,
            // permissionName: Permission.ATTENDANCE_MINE,
            isDisplayInProd: true,
            hideInSideNav: true,
          },
          {
            path: `/account-details/${this._util.accountID}/Billing-History`,
            title: "Billing-History",
            type: "default",
            moduleName: "Billing-History",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-profile-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [],
            position: '54px',
            isPrivileged: true,
            // permissionName: Permission.ATTENDANCE_MINE,
            isDisplayInProd: true,
            hideInSideNav: true,
          },
        ],
        position: '54px',
        isPrivileged: true,
        // permissionName: Permission.ATTENDANCE_MINE,
        isDisplayInProd: true,
      },
      {
        path: "/scheduling/tasks",
        title: "Scheduling",
        type: "default",
        moduleName: "accounts",
        iconType: "material-icons",
        icon: "face",
        iconPath: "assets/images/icons/new-my-profile-icon.svg",
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        hideInSideNav: true,
        submenu: [
          {
            path: `/account-details/${this._util.accountID}/schedules`,
            title: "Schedules",
            type: "default",
            moduleName: "Schedules",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-profile-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [],
            position: '54px',
            isPrivileged: true,
            // permissionName: Permission.ATTENDANCE_MINE,
            isDisplayInProd: true,
            hideInSideNav: true,
          },
          {
            path: `/account-details/${this._util.accountID}/Subscription`,
            title: "Subscription",
            type: "default",
            moduleName: "Subscription",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-profile-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [],
            position: '54px',
            isPrivileged: true,
            // permissionName: Permission.ATTENDANCE_MINE,
            isDisplayInProd: true,
            hideInSideNav: true,
          },
          {
            path: `/account-details/${this._util.accountID}/Billing-History`,
            title: "Billing-History",
            type: "default",
            moduleName: "Billing-History",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-profile-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [],
            position: '54px',
            isPrivileged: true,
            // permissionName: Permission.ATTENDANCE_MINE,
            isDisplayInProd: true,
            hideInSideNav: true,
          },
        ],
        position: '54px',
        isPrivileged: true,
        // permissionName: Permission.ATTENDANCE_MINE,
        isDisplayInProd: true,
      },
      {
        path: "/scheduling/tasks",
        title: "Scheduling",
        type: "default",
        moduleName: "scheduling",
        iconType: "material-icons",
        icon: "face",
        iconPath:this.getIconPath('time-off'),
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        submenu: [
          {
            path: `/scheduling/tasks`,
            title: "Tasks",
            type: "default",
            moduleName: "tasks",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-profile-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [],
            position: '54px',
            isPrivileged: true,
            // permissionName: Permission.ATTENDANCE_MINE,
            isDisplayInProd: true,
            hideInSideNav: true,
          },
          {
            path: `/scheduling/schedule`,
            title: "Schedule",
            type: "default",
            moduleName: "schedule",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-profile-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [],
            position: '54px',
            isPrivileged: true,
            // permissionName: Permission.ATTENDANCE_MINE,
            isDisplayInProd: true,
            hideInSideNav: true,
          },
        ],
        position: '54px',
        isPrivileged: true,
        // permissionName: Permission.EMPLOYEES,
        isDisplayInProd: true
      },
      {
        path: "holiday-calender",
        title: "Holiday Calender",
        type: "default",
        moduleName: "holiday-Calender",
        iconType: "material-icons",
        icon: "face",
        iconPath:"assets/images/icons/new-leave-icon.svg",
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        submenu: [],
        position: '331px',
        isPrivileged: false,
        // permissionName: "",
        isDisplayInProd: true
      },
      {
        path: "/roles-permissions/permission",
        title: "Roles & Permissions",
        type: "default",
        moduleName: "roles-permissions",
        iconType: "material-icons",
        icon: "schedule",
        iconPath:'assets/images/icons/roles&permission.svg',
        // this.getIconPath('roles&permission')
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        submenu: [
          // {
          //   path: `/roles-permissions/permission`,
          //   title: "Permission",
          //   type: "default",
          //   moduleName: "permission",
          //   iconType: "material-icons",
          //   icon: "face",
          //   iconPath: "assets/images/icons/new-my-profile-icon.svg",
          //   class: "",
          //   groupTitle: true,
          //   badge: "",
          //   badgeClass: "",
          //   submenu: [],
          //   position: '54px',
          //   isPrivileged: true,
          //   // permissionName: Permission.ATTENDANCE_MINE,
          //   isDisplayInProd: true,
          //   hideInSideNav: true,
          // },
          // {
          //   path: `/roles-permissions/groups`,
          //   title: "Groups",
          //   type: "default",
          //   moduleName: "groups",
          //   iconType: "material-icons",
          //   icon: "face",
          //   iconPath: "assets/images/icons/new-my-profile-icon.svg",
          //   class: "",
          //   groupTitle: true,
          //   badge: "",
          //   badgeClass: "",
          //   submenu: [],
          //   position: '54px',
          //   isPrivileged: true,
          //   // permissionName: Permission.ATTENDANCE_MINE,
          //   isDisplayInProd: true,
          //   hideInSideNav: true,
          // },
        ],
        position: '239px',
        isPrivileged: true,
        // permissionName: Permission.LEAVE,
        isDisplayInProd: true,
      },
      {
        path: "/statutory-compliance/india",
        title: "Statutory Compliance",
        type: "default",
        moduleName: "india",
        iconType: "fas",
        icon: "fa-ticket-alt",
        iconPath:'assets/images/icons/statutory-comp-icon.svg',
        // this.getIconPath('statutory-comp-icon')
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        submenu: [

          {
            path: `/statutory-compliance/india/pf`,
            title: "India",
            type: "default",
            moduleName: "india",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-team-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [
              {
                path: `/statutory-compliance/india/pf`,
                title: "Provident Fund",
                type: "default",
                moduleName: "pf",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                // permissionName: Permission.ATTENDANCE_TEAM,
                hideInSideNav: true,
              },
              {
                path: `/statutory-compliance/india/esi`,
                title: "Employees' State Insurance",
                type: "default",
                moduleName: "esi",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                // permissionName: Permission.ATTENDANCE_TEAM,
                hideInSideNav: true,
              },
              {
                path: `/statutory-compliance/india/lwf`,
                title: "Labour Welfare Fund",
                type: "default",
                moduleName: "lwf",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                // permissionName: Permission.ATTENDANCE_TEAM,
                hideInSideNav: true,
              },
              {
                path: `/statutory-compliance/india/pt`,
                title: "Professional Tax",
                type: "default",
                moduleName: "pt",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                // permissionName: Permission.ATTENDANCE_TEAM,
                hideInSideNav: true,
              },
              {
                path: `/statutory-compliance/india/tds`,
                title: "Tax Deducted At Source",
                type: "default",
                moduleName: "tds",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                // permissionName: Permission.ATTENDANCE_TEAM,
                hideInSideNav: true,
              },
              {
                path: `/statutory-compliance/india/gratuity`,
                title: "Gratuity",
                type: "default",
                moduleName: "gratuity",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                // permissionName: Permission.ATTENDANCE_TEAM,
                hideInSideNav: true,
              },
              {
                path: `/statutory-compliance/india/statutory-bonus`,
                title: "Statutory Bonus",
                type: "default",
                moduleName: "statutory-bonus",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                // permissionName: Permission.ATTENDANCE_TEAM,
                hideInSideNav: true,
              },

            ],
            position: '54px',
            isPrivileged: true,
            isDisplayInProd: true,
            // permissionName: Permission.ATTENDANCE_TEAM,
            hideInSideNav: true,
          },
          {
            path: `/statutory-compliance/malaysia/epf`,
            title: "Malaysia",
            type: "default",
            moduleName: "malaysia",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-team-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [
              {
                path: `/statutory-compliance/malaysia/epf`,
                title: "Employee Provident Fund",
                type: "default",
                moduleName: "epf ",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                // permissionName: Permission.ATTENDANCE_TEAM,
                hideInSideNav: true,
              },
              {
                path: `/statutory-compliance/malaysia/eis`,
                title: "Employment Insurance System",
                type: "default",
                moduleName: "eis",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                // permissionName: Permission.ATTENDANCE_TEAM,
                hideInSideNav: true,
              },
              {
                path: `/statutory-compliance/malaysia/socso`,
                title: "Social Security Organization",
                type: "default",
                moduleName: "socso",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                // permissionName: Permission.ATTENDANCE_TEAM,
                hideInSideNav: true,
              },
            ],
            position: '54px',
            isPrivileged: true,
            isDisplayInProd: true,
            // permissionName: Permission.ATTENDANCE_TEAM,
            hideInSideNav: true,
          },
       
        ],
        position: '331px',
        isPrivileged: false,
        // permissionName: "",
        isDisplayInProd: true
      },
      {
        path: `/subscription/accounts`,
        title: "Subscription",
        type: "default",
        moduleName: "subscription",
        iconType: "material-icons",
        icon: "schedule",
        iconPath:this.getIconPath('new-attendance-icon'),
        class: "",
        groupTitle: true,
        // permissionName: Permission.ATTENDANCE,
        badge: "",
        badgeClass: "",
        submenu: [
          {
            path: `/subscription/accounts`,
            title: "Accounts",
            type: "default",
            moduleName: "accounts",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-team-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [
              {
                path: `/subscription/accounts/overview`,
                title: "Overview",
                type: "default",
                moduleName: "overview",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                hideInSideNav: true,
              },
              {
                path: `/subscription/accounts/subscription`,
                title: "Subscription",
                type: "default",
                moduleName: "subscription",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                hideInSideNav: true,
              },
              {
                path: `/subscription/accounts/billing`,
                title: "Billing",
                type: "default",
                moduleName: "billing",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                hideInSideNav: true,
              },
              {
                path: `/subscription/accounts/usage`,
                title: "Usage",
                type: "default",
                moduleName: "usage",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                hideInSideNav: true,
              },
              {
                path: `/subscription/accounts/activity`,
                title: "Activity",
                type: "default",
                moduleName: "activity",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                hideInSideNav: true,
              },
              {
                path: `/subscription/accounts/contacts`,
                title: "Contacts",
                type: "default",
                moduleName: "contacts",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-team-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                hideInSideNav: true,
              }
            ],
            position: '54px',
            isPrivileged: true,
            isDisplayInProd: true,
            hideInSideNav: true,
          },
          {
            path: `/subscription/pricing`,
            title: "Pricing",
            type: "default",
            moduleName: "pricing",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-team-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [],
            position: '54px',
            isPrivileged: true,
            isDisplayInProd: true,
            // permissionName: Permission.ATTENDANCE_TEAM,
            hideInSideNav: true,
          },
          {
            path: `/subscription/plans`,
            title: "Plans",
            type: "default",
            moduleName: "plans",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-profile-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [],
            position: '54px',
            isPrivileged: true,
            // permissionName: Permission.ATTENDANCE_MINE,
            isDisplayInProd: true,
            hideInSideNav: true,
          },
          {
            path: `/subscription/config`,
            title: "Config",
            type: "default",
            moduleName: "config",
            iconType: "material-icons",
            icon: "face",
            iconPath: "assets/images/icons/new-my-profile-icon.svg",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            submenu: [
              {
                path: `/subscription/config/features`,
                title: "Features",
                type: "default",
                moduleName: "plans",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-profile-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                // permissionName: Permission.ATTENDANCE_MINE,
                isDisplayInProd: true,
                hideInSideNav: true,
              },

              {
                path: `/subscription/config/limitations`,
                title: "Access Limit",
                type: "default",
                moduleName: "limitations",
                iconType: "material-icons",
                icon: "face",
                iconPath: "assets/images/icons/new-my-profile-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                hideInSideNav: true,
              },
              {
                path: `/subscription/config/configuration`,
                title: "Configuration",
                type: "default",
                moduleName: "configuration",
                iconType: "material-icons",
                icon: "settings",
                iconPath: "assets/images/icons/new-my-profile-icon.svg",
                class: "",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                submenu: [],
                position: '54px',
                isPrivileged: true,
                isDisplayInProd: true,
                hideInSideNav: true,
              }
            ],
            position: '54px',
            isPrivileged: true,
            isDisplayInProd: true,
            hideInSideNav: true,
          }
        ],
        position: '239px',
        isPrivileged: true,
        isDisplayInProd: true,
      },
      {
        path: "setup",
        title: "Setup",
        type: "default",
        moduleName: "setup",
        iconType: "fas",
        icon: "",
        iconPath:'assets/images/icons/new-my-team-icon.svg',
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        submenu: [],
        position: '331px',
        isPrivileged: false,
        // permissionName: "",
        isDisplayInProd: true
      },
   
      {
        path: "support",
        title: "Support",
        type: "default",
        moduleName: "support",
        iconType: "fas",
        icon: "fa-ticket-alt",
        iconPath:this.getIconPath('support'),
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        submenu: [],
        position: '331px',
        isPrivileged: false,
        // permissionName: "",
        isDisplayInProd: true
      },
      // {
      //   path: "/calendar",
      //   title: "Calendar",
      //   type: "default",
      //   moduleName: "calendar",
      //   iconType: "fas",
      //   icon: "fa-calendar-alt",
      //   class: "",
      //   groupTitle: true,
      //   badge: "",
      //   badgeClass: "",
      //   submenu: [],
      // },
      /* 
      {
        path: "/logout",
        title: "Logout",
        moduleName: "logout",
        iconType: "material-icons",
        icon: "power_settings_new",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        
        submenu: [],
      }, */
    
    
      // Settings side menu items
      /* {
        path: "",
        title: "-- Main",
        type: "settings",
        moduleName: "",
        iconType: "",
        icon: "",
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        submenu: [],
      },
    
      {
        path: "/settings/accounts",
        title: "Accounts",
        type: "settings",
        moduleName: "accounts",
        iconType: "material-icons",
        icon: "business",
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        submenu: [],
        position: '54px'
      }, */
      {
        path: "/settings/user",
        title: "user",
        type: "settings",
        moduleName: "settings",
        iconType: "wz-custom-icons",
        iconPath: this.getIconPath('organization'),
        icon: "",
        class: "",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        isPrivileged: true,
        // permissionName: Permission.ORG_CONFIG,
        position: '54px',
        isDisplayInProd: true,
        submenu: [],    
      },
          {
            path: "/settings/roles-and-permission",
            title: "Roles & Permissions",
            type: "settings",
            moduleName: "roles-and-permission",
            iconType: "wz-custom-icons",
            iconPath: 'assets/images/icons/roles&permission.svg',
            icon: "",
            class: "",
            groupTitle: true,
            badge: "",
            badgeClass: "",
            position: '376px',
            isPrivileged: true,
            // permissionName: Permission.GROUPS,
            isDisplayInProd: true,
            submenu: []
          }
    ];
  }

  getIconPath(icon: any) {
    let theme = this._util.theme !== 'menu_dark' ? `${this._util.theme.split('_')[1] + '-'}` : ''
    return `assets/images/icons/${theme + icon}.svg`
  }
}